import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "@phosphor-icons/react";
import { useSeo } from "@/lib/useSeo";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/cleaning", label: "House Cleaning" },
  { to: "/deep-cleaning", label: "Deep Cleaning" },
  { to: "/carpet-cleaning", label: "Carpet Cleaning" },
  { to: "/move-out-cleaning", label: "Move-Out Cleaning" },
  { to: "/same-day-cleaning", label: "Same-Day Cleaning" },
  { to: "/landlord-turnover", label: "Rental Turnovers" },
  { to: "/fresh-start", label: "Fresh Start Transformation" },
  { to: "/hoarding-cleanup", label: "Hoarding Cleanup" },
  { to: "/estate-cleanout", label: "Estate Cleanouts" },
  { to: "/junk-removal", label: "Junk Removal" },
  { to: "/basement-garage-cleanout", label: "Basement & Garage Cleanouts" },
  { to: "/digital", label: "Digital Services" },
];

// Soft-404: static hosting always answers 200 for SPA routes, so we signal "not found" via title + noindex + visible copy.
export default function NotFound() {
  useSeo({ title: "Page not found (404) — HCOB Property Services", description: "This page doesn't exist. Find our cleaning, junk removal and property services for Baltimore and all of Maryland.", path: null, robots: "noindex, follow" });
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-[#F5F4F0] px-6 py-16 text-[#1C1A17]" data-testid="not-found-page">
      <div className="w-full max-w-xl">
        <div className="font-mono-label text-[11px] tracking-[0.28em] text-[#C84B31]">Error 404</div>
        <h1 className="mt-3 font-display text-4xl font-black leading-[1.02] tracking-tight sm:text-5xl" data-testid="not-found-heading">
          That page doesn't exist.
        </h1>
        <p className="mt-4 text-[15px] leading-relaxed text-[#5C6470]">
          The link may be old or mistyped. Everything we do is one click away below — or call and a coordinator will point you to the right place.
        </p>
        <ul className="mt-8 divide-y divide-[#1C1A17]/10 border-y border-[#1C1A17]/10">
          {LINKS.map((l) => (
            <li key={l.to}>
              <a href={l.to} className="group flex min-h-[48px] items-center justify-between py-3 text-[15px] font-bold hover:text-[#C84B31]" data-testid={`not-found-link-${l.to === "/" ? "home" : l.to.slice(1)}`}>
                {l.label}
                <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-1" />
              </a>
            </li>
          ))}
        </ul>
        <div className="mt-8 flex flex-wrap items-center gap-4">
          <a href="tel:+14108709347" className="inline-flex min-h-[48px] items-center gap-2 bg-[#C84B31] px-5 text-[14px] font-black text-[#F5F4F0] hover:bg-[#A03A24]" data-testid="not-found-call">
            <Phone size={16} weight="fill" /> (410) 870-9347
          </a>
          <Link to="/" className="text-[14px] font-bold underline underline-offset-4 hover:text-[#C84B31]" data-testid="not-found-home">
            Back to homepage
          </Link>
        </div>
      </div>
    </main>
  );
}
